function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 0c1.1 0 2 .868 2 1.929V13.5c0 1.06-.9 1.929-2 1.929H2c-1.11 0-2-.868-2-1.929V1.929C0 .868.89 0 2 0zM7 4.821H4c-.55 0-1 .434-1 .965v3.857c0 .53.45.964 1 .964h3c.55 0 1-.434 1-.964v-.964H6.5v.482h-2V6.268h2v.482H8v-.964c0-.53-.45-.965-1-.965zm7 0h-3c-.55 0-1 .434-1 .965v3.857c0 .53.45.964 1 .964h3c.55 0 1-.434 1-.964v-.964h-1.5v.482h-2V6.268h2v.482H15v-.964c0-.53-.45-.965-1-.965z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgClosedCaptionOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedCaptionOn);
export default __webpack_public_path__ + "static/media/closedCaption-on.c5c8118d.svg";
export { ForwardRef as ReactComponent };